import * as request from 'services/request'

export const actionTypes = {
  TENANTS_RECEIVED: 'TENANTS_RECEIVED'
}

export const tenantsReceived = tenants => ({
  type: actionTypes.TENANTS_RECEIVED,
  payload: tenants
})

export function getTenants () {
  return async dispatch => {
    const response = await request.authorized('/tenants')
    const tenants = await response.json()

    dispatch(tenantsReceived(tenants))
  }
}



// WEBPACK FOOTER //
// ./src/components/with-tenants/container/actions.js